"use strict";
exports.__esModule = true;
exports.chart_global_layout_Width = {
  "name": "--pf-chart-global--layout--Width",
  "value": 450,
  "var": "var(--pf-chart-global--layout--Width, 450)"
};
exports["default"] = exports.chart_global_layout_Width;